import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import { Card, CardBody } from "../../../../components/card/card";
import { useState } from "react";
import DateFormat from "../../../../components/dateFormater/dateFormat1";
import { atmpTrainingDetail } from "../../../../config/apiSPA";

function ModalParticipantAtmp({ show, onHide, id, submitClick }) {
  const [loading, setLoading] = useState(true);
  const [atmpData, setAtmpData] = useState();
  function onShow() {
    setLoading(true);
    atmpTrainingDetail(id).then((res) => {
      setLoading(false);
      setAtmpData(res.data);
    });
  }
  return (
    <>
      <Modal size="lg" show={show} onShow={onShow} onHide={() => onHide()}>
        <ModalHeader closeButton>
          <h5 className="modal-title">ATMP Participant List</h5>
        </ModalHeader>
        <ModalBody>
          {loading ? (
            <p>Loading...</p>
          ) : (
            <>
              <Resume data={atmpData} />
              <Card>
                <CardBody>
                  <>
                    <div className="table-responsive">
                      <table className="table table-hover text-nowrap">
                        <thead>
                          <tr>
                            <th className="border-top-0 pt-0 pb-2">No</th>
                            <th className="border-top-0 pt-0 pb-2">NRP</th>
                            <th className="border-top-0 pt-0 pb-2">Name</th>
                            <th className="border-top-0 pt-0 pb-2">Position</th>
                            <th className="border-top-0 pt-0 pb-2">Mandatory</th>
                          </tr>
                        </thead>
                        <tbody>
                          {atmpData.participant.length > 0 ? (
                            <>
                              {atmpData.participant.map((val, index) => (
                                <tr key={index}>
                                  <td className="align-middle">{index + 1}</td>
                                  <td className="align-middle">{val.manpower.nrp}</td>
                                  <td className="align-middle">{val.manpower.nama}</td>
                                  <td className="align-middle">{val.manpower.jabatanFn}</td>
                                  <td className="align-middle">{val.trainingType === "MANDATORY" ? "YES" : "NO"}</td>
                                </tr>
                              ))}
                            </>
                          ) : (
                            <td className="align-middle">No Participant</td>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </>
                </CardBody>
              </Card>
            </>
          )}
        </ModalBody>
        <ModalFooter></ModalFooter>
      </Modal>
    </>
  );
}

export default ModalParticipantAtmp;

function Resume({ data }) {
  function checkTanggal(tanggalString) {
    const tanggal = new Date(tanggalString);
    const tahun = tanggal.getFullYear();

    if (tahun < 2000) {
      return "tentative";
    } else {
      return DateFormat(tanggalString);
    }
  }
  return (
    <>
      <div className="mb-3">
        <div className="fw-400">
          <strong className="text-theme">{data.kodeTraining.title}</strong>
          {data.instructor.namaInstructor !== "-" ? ` by ${data.instructor.namaInstructor}` : " <instructor tentative>"}
        </div>
        {data.startDate === data.endDate ? (
          <div className="small text-inverse text-opacity-50">{checkTanggal(data.startDate)}</div>
        ) : (
          <div className="small text-inverse text-opacity-50">{`${DateFormat(data.startDate)} -- ${DateFormat(data.endDate)}`}</div>
        )}
      </div>
    </>
  );
}
